import { Toolbar } from './Toolbar';
import { User } from 'types/User';

export const ToolbarHOC =
    (usersFilter: any, setUsersFilter: any, usersList: User[], colors: string[], setOpenCreateEventModal: (open: boolean) => void, isLoading: boolean) =>
    (props: any) => (
        <Toolbar
            {...props}
            usersFilter={usersFilter}
            setUsersFilter={setUsersFilter}
            usersList={usersList}
            colors={colors}
            setOpenCreateEventModal={setOpenCreateEventModal}
            isLoading={isLoading}
        />
    );
